{
  "name": "admin-portal",
  "version": "0.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4200",
    "e2e": "concurrently \"npm run start\" \"cd ../e2e && wait-on http://localhost:4200 && cross-env ADMIN_PORTAL_V2_BASE_URL=http://localhost:4200 npm run dashboard\"",
    "build:staging": "ng build --configuration=staging",
    "build:production": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --watch=false --browsers=ChromeHeadless",
    "test:dev": "ng test",
    "lint": "ng lint",
    "format": "prettier --write \"src/**/*.{ts,html,scss}\""
  },
  "private": true,
  "overrides": {
    "fast-uri": "^3.1.5"
  },
  "dependencies": {
    "@angular-eslint/eslint-plugin": "^21.0.1",
    "@amcharts/amcharts5": "^5.11.1",
    "@angular-eslint/eslint-plugin-template": "^21.0.1",
    "@angular-eslint/schematics": "^21.0.1",
    "@angular-eslint/template-parser": "^21.0.1",
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@datadog/browser-logs": "^5.35.1",
    "@datadog/browser-rum": "^5.34.1",
    "@everyday-speech/eds-design-system-lib": "latest",
    "chart.js": "^4.4.8",
    "eslint": "^9.15.0",
    "papaparse": "^5.5.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "userpilot": "^1.3.6",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.18",
    "@angular/cli": "^21.2.18",
    "@angular/compiler-cli": "^21.2.25",
    "@types/jasmine": "~5.1.0",
    "@types/papaparse": "^5.3.15",
    "angular-eslint": "^21.0.0",
    "concurrently": "^9.1.2",
    "cross-env": "^7.0.3",
    "eslint": "^9.15.0",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.3.3",
    "typescript": "5.9.3",
    "typescript-eslint": "8.15.0",
    "wait-on": "^8.0.2"
  }
}
